import { client } from "~/openapi/client.gen";

export default defineNuxtRouteMiddleware(async (to, from) => {

     const { validate, isLoggedIn, accessToken } = useAuth();

     await validate(accessToken?.value ?? "")

     if (accessToken.value) {
          client.setConfig({
               headers: {
                    common: {
                         'Authorization': 'Bearer ' + accessToken.value
                    }
               }
          });
     }

     if (to.path !== "/admin/login") {
          if (!isLoggedIn.value) {
               return navigateTo("/admin/login");
          }
     }
});